import React from 'react';

import { HomeCardBack } from '../home-card-back';

export interface HomeBusinessCardBackProps
  extends Readonly<{
    onButtonPress: () => void;
    style?: React.CSSProperties;
  }> {}

export const HomeBusinessCardBack = React.memo<HomeBusinessCardBackProps>((props) => {
  const { onButtonPress, style } = props;

  return (
    <HomeCardBack
      icon={'gear'}
      iconColor={'secondary'}
      empasized={'90% reduction'}
      description={'in time to identify root cause of failed orders'}
      title={'Turn operations into an efficient business enabler'}
      onButtonPress={onButtonPress}
      style={style}
    />
  );
});
